<template>
  <div class="s-strip s-leasing-offers-compare">
    <div class="page-container">
      <SlickCarousel
        ref="slick"
        class="s-leasing-offers-compare__slick"
        :options="slickOptions">
        <div v-for="item in records" :key="item.id" class="item">
          <div class="row gx-5 mb-80">
            <div class="col">
              <VehicleCompareCard
                :item="item"
                @change-vat="onToggleVatIncluded" />
              <button
                type="button"
                class="btn btn-link btn-remove"
                :disabled="records.length < 3"
                @click="removeVehicle(item.id)">
                {{ dictionary.removeVehicleButtonText }}
              </button>
            </div>
          </div>

          <div class="b-tech-characteristics-table stand-alone mb-40">
            <div class="row gx-5">
              <div class="col">
                <span>{{ dictionary.transmissionLabel }}:</span>
                <span>{{ item.transmissionType }}</span>
              </div>
            </div>
            <div class="row gx-5">
              <div class="col">
                <span>{{ dictionary.fuelLabel }}:</span>
                <span>{{ item.fuel }}</span>
              </div>
            </div>
            <div class="row gx-5">
              <div class="col">
                <span>{{ dictionary.consumptionLabel }}:</span>
                <span>{{ item.consumption }}</span>
              </div>
            </div>
            <div class="row gx-5">
              <div class="col">
                <span>{{ dictionary.emissionsLabel }}:</span>
                <span>{{ item.emissions }}</span>
              </div>
            </div>
          </div>

          <div class="row gx-5">
            <div v-auto-animate class="col">
              <ul class="flex-column s-fleet-leasing__space-box">
                <div class="s-fleet-leasing__box">
                  <h2 class="s-fleet-leasing__box__title mb-10">
                    {{ dictionary.saverLabel }}
                  </h2>
                  <li
                    v-for="(option, index) in getFlexArray(item)"
                    :key="index"
                    class="d-flex flex-column">
                    <span v-if="!(Object.keys(option).length === 0)">
                      {{ dictionary.yearsPrefix }} {{ option.years }}
                      {{ dictionary.yearsSuffix }}
                    </span>
                    <span v-else>&nbsp;</span>
                    <div class="mb-20">
                      <span
                        v-if="!(Object.keys(option).length === 0)"
                        class="s-fleet-leasing__box__prices">
                        <template v-if="item.vatIncluded">
                          {{ option.priceInclVat }}
                        </template>
                        <template v-else>{{ option.price }}</template>

                        {{ dictionary.vehiclePriceSuffix }}
                      </span>
                      <span v-else class="s-fleet-leasing__box__prices">
                        &nbsp;
                      </span>
                    </div>
                  </li>
                </div>
              </ul>
              <ul class="flex-column s-fleet-leasing__space-box">
                <div class="s-fleet-leasing__box theme-black">
                  <h2 class="s-fleet-leasing__box__title mb-10">
                    {{ dictionary.saverPlusLabel }}
                  </h2>
                  <li
                    v-for="(option, index) in getSaverArray(item)"
                    :key="index">
                    <span v-if="!(Object.keys(option).length === 0)">
                      {{ dictionary.yearsPrefix }} {{ option.years }}
                      {{ dictionary.yearsSuffix }}
                    </span>
                    <span v-else>&nbsp;</span>
                    <div
                      v-if="!(Object.keys(option).length === 0)"
                      class="mb-20">
                      <span class="s-fleet-leasing__box__prices">
                        <template v-if="item.vatIncluded">
                          {{ option.priceInclVat }}
                        </template>
                        <template v-else>{{ option.price }}</template>

                        {{ dictionary.vehiclePriceSuffix }}
                      </span>
                    </div>
                    <div v-else class="mb-20">
                      <span class="s-fleet-leasing__box__prices">&nbsp;</span>
                    </div>
                  </li>
                </div>
              </ul>
            </div>
          </div>

          <AccordionLarge
            v-if="hasEquipement"
            :title="dictionary.equipmentTitle"
            :is-active-prop="true"
            class="theme-grey theme-icon-cirle mb-80">
            <div style="padding: 20px">
              <div class="row gx-5">
                <div class="col"></div>
                <!-- col -->
                <div v-auto-animate class="col">
                  <ul class="is-checked">
                    <li v-for="(spec, index) in getSpecs(item)" :key="index">
                      {{ spec }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </AccordionLarge>
        </div>
      </SlickCarousel>
    </div>
  </div>
</template>

<script>
import * as lib from './../../lib/lib'
import constants from './../../lib/constants'
import VehicleCompareCard from './../components/leasingOffers/VehicleCompareCard.vue'
import AccordionLarge from './../components/BookingAccordion.vue'
import SlickCarousel from './../components/common/SlickCarousel.vue'

export default {
  components: {
    AccordionLarge,
    VehicleCompareCard,
    SlickCarousel,
  },
  data() {
    return {
      records: [],
      slickOptions: {
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      },
    }
  },
  computed: {
    hasEquipement() {
      if (this.records.find((x) => x.characteristics.length)) {
        return true
      }
      return false
    },
  },
  mounted() {
    const { records } = lib.getData('leasingCompareData')
    this.records = records
    this.records.forEach((x) => (x.vatIncluded = false))

    this.$nextTick(() => {
      this.setFlexMostOptions()
      this.setSaverMostOptions()
    })
  },

  methods: {
    getSpecs(value) {
      return value.characteristics
    },
    setFlexMostOptions() {
      let mostOptionsLenght = 0

      for (let i = 0; i < this.records.length; i++) {
        if (mostOptionsLenght < this.records[i].flexPrices.length) {
          mostOptionsLenght = this.records[i].flexPrices.length
        }
      }
      for (let i = 0; i < this.records.length; i++) {
        while (mostOptionsLenght > this.records[i].flexPrices.length) {
          this.records[i].flexPrices.push({})
        }
      }
    },
    setSaverMostOptions() {
      let mostOptionsLenght = 0

      for (let i = 0; i < this.records.length; i++) {
        if (mostOptionsLenght < this.records[i].saverPrices.length) {
          mostOptionsLenght = this.records[i].saverPrices.length
        }
      }
      for (let i = 0; i < this.records.length; i++) {
        while (mostOptionsLenght > this.records[i].saverPrices.length) {
          this.records[i].saverPrices.push({})
        }
      }
    },
    removeVehicle(id) {
      this.records = this.records.filter((x) => x.id !== id)

      for (let i = 0; i < this.records.length; i++) {
        const entry = this.records[i].flexPrices
        this.records[i].flexPrices = entry.filter(
          (x) => Object.keys(x).length !== 0
        )
      }

      for (let i = 0; i < this.records.length; i++) {
        const entry = this.records[i].saverPrices
        this.records[i].saverPrices = entry.filter(
          (x) => Object.keys(x).length !== 0
        )
      }

      this.setFlexMostOptions()
      this.setSaverMostOptions()
    },
    getFlexArray(value) {
      return value.flexPrices
    },
    getSaverArray(value) {
      return value.saverPrices
    },
    getTransmissionLabel(value) {
      let res
      const { manual, auto } = constants.leaseitnow.filters.transmissionsOptions

      switch (value) {
        case manual:
          res = this.dictionary.transmissionManual
          break
        case auto:
          res = this.dictionary.transmissionAutomatic
          break
        default:
          res = null
      }
      return res
    },
    onToggleVatIncluded(value, id) {
      this.records.find((x) => x.id === id).vatIncluded = value
    },
  },
}
</script>

<style lang="scss" scoped>
.s-fleet-leasing {
  &__space-box {
    margin-bottom: 20px;
  }

  &__box {
    width: 100%;
    height: unset;
    border-radius: 8px;

    &__title {
      font-weight: 700;
      font-size: 20px;
    }
    &__prices {
      font-weight: 700;
      font-size: 20px;
      line-height: 22px;
    }
  }
}
</style>
